import { authedFetch } from '@/lib/api-client'

// Wire format de la API (ver /specs/api.md + /specs/admin-dashboard.md seccion
// "Usuarios - lista"). Endpoint admin: GET /admin/users.

export type Membership = 'all' | 'active' | 'inactive'
export type DeletedFilter = 'all' | 'true' | 'false'
export type SuspendedFilter = 'all' | 'true' | 'false'

export interface AdminUser {
  id: string
  nombre: string
  apellido: string
  email: string
  telefono: string
  rol: 'ALUMNO' | 'DOCENTE' | 'ADMIN'
  authProvider: 'GOOGLE' | 'APPLE' | 'PASSWORD'
  activeUntil: string | null
  deletedAt: string | null
  /** ISO date si esta suspendido (baja reversible); null si activo. */
  suspendedAt: string | null
  createdAt: string
  followersCount: number
  followingCount: number
}

export interface AdminUserListResponse {
  items: AdminUser[]
  nextCursor: string | null
}

export interface ListUsuariosParams {
  search?: string
  membership?: Membership
  deleted?: DeletedFilter
  suspended?: SuspendedFilter
  limit?: number
  cursor?: string | null
}

export async function listUsuarios(
  params: ListUsuariosParams = {},
): Promise<AdminUserListResponse> {
  const search = new URLSearchParams()
  if (params.search && params.search.trim().length > 0) {
    search.set('search', params.search.trim())
  }
  if (params.membership && params.membership !== 'all') {
    search.set('membership', params.membership)
  }
  // 'false' es el default del endpoint; lo omitimos para mantener URLs limpias.
  if (params.deleted && params.deleted !== 'false') {
    search.set('deleted', params.deleted)
  }
  // 'all' es el default del endpoint para suspended; lo omitimos.
  if (params.suspended && params.suspended !== 'all') {
    search.set('suspended', params.suspended)
  }
  search.set('limit', String(params.limit ?? 50))
  if (params.cursor) search.set('cursor', params.cursor)

  return authedFetch<AdminUserListResponse>(
    `/admin/users?${search.toString()}`,
    { method: 'GET' },
  )
}

// Baja/alta reversible (suspension). Solo ADMIN. No aplica a otros ADMIN.
export async function suspendUser(id: string): Promise<AdminUser> {
  return authedFetch<AdminUser>(`/admin/users/${id}/suspend`, { method: 'POST' })
}

export async function reactivateUser(id: string): Promise<AdminUser> {
  return authedFetch<AdminUser>(`/admin/users/${id}/reactivate`, { method: 'POST' })
}
